module.exports = __webpack_public_path__ + "static/media/paypal.2ea92f9a.svg";